"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _settings = _interopRequireDefault(require("@/settings"));
var _cache = _interopRequireDefault(require("@/plugins/cache"));
var _systemConfig = require("@/api/systemConfig");
var _systemSetting = require("@/api/systemSetting");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

var showSettings = _settings.default.showSettings,
  tagsView = _settings.default.tagsView,
  fixedHeader = _settings.default.fixedHeader,
  sidebarLogo = _settings.default.sidebarLogo,
  topNav = _settings.default.topNav,
  sideTheme = _settings.default.sideTheme,
  navIcon = _settings.default.navIcon;
var storageSetting = _cache.default.local.has('layout-setting') ? _cache.default.local.getJSON('layout-setting') : '';
var state = {
  theme: storageSetting.theme || '#409EFF',
  sideTheme: storageSetting.sideTheme || sideTheme,
  topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
  showSettings: showSettings,
  tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
  fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
  sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
  navIcon: storageSetting.navIcon === undefined ? navIcon : storageSetting.navIcon,
  frontDomain: localStorage.getItem('frontDomain') || '',
  //移动端域名
  mediaDomain: '',
  // localStorage.getItem('mediaDomain') || '', //图片域名
  merchantAddrMaps: {},
  introTypeList: []
};
var mutations = {
  CHANGE_SETTING: function CHANGE_SETTING(state, _ref) {
    var key = _ref.key,
      value = _ref.value;
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
  // 移动端域名
  SET_FrontDomain: function SET_FrontDomain(state, frontDomain) {
    state.frontDomain = frontDomain;
    localStorage.setItem('frontDomain', frontDomain);
    if (!frontDomain) localStorage.removeItem('frontDomain');
  },
  // 线上文件、图片域名地址
  SET_mediaDomain: function SET_mediaDomain(state, mediaDomain) {
    state.mediaDomain = mediaDomain;
    if (!mediaDomain) localStorage.removeItem('mediaDomain');
  },
  // 简介列表
  SET_IntroTypeList: function SET_IntroTypeList(state, list) {
    state.introTypeList = list;
  },
  // 售后地址
  SET_MerchantAddrMaps: function SET_MerchantAddrMaps(state, _ref2) {
    var merId = _ref2.merId,
      list = _ref2.list;
    state.merchantAddrMaps[merId] = list;
  }
};
var actions = {
  changeSetting: function changeSetting(_ref3, data) {
    var commit = _ref3.commit;
    commit('CHANGE_SETTING', data);
  },
  // 获取线上文件、图片域名
  getMediaDomain: function getMediaDomain(_ref4) {
    var commit = _ref4.commit,
      state = _ref4.state;
    return (0, _systemConfig.mediadomainApi)().then(function (res) {
      localStorage.setItem('mediaDomain', res);
      commit('SET_mediaDomain', res);
    });
  },
  // 获取简介列表
  getIntroTypeList: function getIntroTypeList(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    if (state.introTypeList && state.introTypeList.length) {
      return state.introTypeList;
    }
    return (0, _systemSetting.introTypeListApi)().then(function (res) {
      var list = [];
      Object.keys(res).forEach(function (key) {
        if (key !== 'id' && res[key]) {
          list.push(res[key]);
        }
      });
      commit('SET_IntroTypeList', list);
      return list;
    });
  },
  // 获取售后地址列表
  getMerchantAddrList: function getMerchantAddrList(_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state;
    var merId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (state.merchantAddrMaps[merId] && state.merchantAddrMaps[merId].length) {
      return state.merchantAddrMaps[merId];
    }
    return (0, _systemSetting.merchantAddressListApi)(merId).then(function (res) {
      var list = res.map(function (item) {
        item.label = "(".concat(item.id, ") \u5730\u5740\uFF1A").concat(item.province).concat(item.city).concat(item.district).concat(item.street).concat(item.detail, "\uFF1B\u59D3\u540D\uFF1A").concat(item.receiverName, "\uFF1B\u7535\u8BDD\uFF1A").concat(item.receiverPhone);
        return item;
      });
      commit('SET_MerchantAddrMaps', {
        merId: merId,
        list: list
      });
      return list;
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};